module.exports = __webpack_public_path__ + "img/faq_cards.ba7bfc7b.png";